import { appBaseQuery } from "@/utils/rtk-query-base";
import { createApi } from "@reduxjs/toolkit/query/react";

export const api = createApi({
  reducerPath: "api",
  baseQuery: appBaseQuery,
  endpoints: () => ({}),
});
